export default function ProductCtaCardSkeleton() {
  return (
    <>
      <div className={`card product-card product-cta-card`}>
        <div className="card-body p-sm-4 p-lg-3 p-xl-4">
          <h2 className="fs-5 mb-3">
            <span className="animated-placeholder height-lg w-80"></span>
          </h2>
          <div className="product-qty d-flex align-items-center justify-content-between py-1">
            <div className="cart-item-qty d-flex align-items-center flex-wrap">
              <div className="input-group me-3 notranslate">
                <button
                  className="qty-btn btn btn-sm btn-light"
                  name="decrement"
                  type="button"
                  aria-label="Decrement"
                  disabled
                >
                  &#8722;
                </button>
                <label className="visually-hidden">Quantity</label>
                <input
                  aria-label="Item Quantity"
                  className="qty-input form-control"
                  pattern="[0-9]"
                  step="1"
                  min="1"
                  name="quantity"
                  type="text"
                  disabled
                />
                <button
                  className="qty-btn btn btn-sm btn-light"
                  name="increment"
                  type="button"
                  aria-label="Increment"
                  disabled
                >
                  &#43;
                </button>
              </div>

              <div className="bulk-discount-toggle d-inline-block text-muted lh-1 my-2">
                <span className="animated-placeholder" style={{ width: '70px' }}></span>
              </div>
            </div>

            <div className="price text-end fw-600 h-100">
              <span className="animated-placeholder" style={{ width: '50px' }}></span>
            </div>
          </div>

          <div className="product-upsells mt-3">
            <h4 className="fs-6">
              <span className="animated-placeholder" style={{ width: '70px' }}></span>
            </h4>
            <div className="form-check mb-2">
              <input className="form-check-input" type="checkbox" disabled />
              <div className="d-flex justify-content-between">
                <label className="form-check-label d-block pe-2">
                  <span className="upsell-name d-inline-block">
                    <span className="animated-placeholder" style={{ width: '150px' }}></span>
                  </span>
                </label>
                <span className="price text-end">
                  <span className="animated-placeholder" style={{ width: '50px' }}></span>
                </span>
              </div>
            </div>
            <div className="form-check mb-2">
              <input className="form-check-input" type="checkbox" disabled />
              <div className="d-flex justify-content-between">
                <label className="form-check-label d-block pe-2">
                  <span className="upsell-name d-inline-block">
                    <span className="animated-placeholder" style={{ width: '150px' }}></span>
                  </span>
                </label>
                <span className="price text-end">
                  <span className="animated-placeholder" style={{ width: '50px' }}></span>
                </span>
              </div>
            </div>
          </div>

          <div className="item-total d-flex align-items-center justify-content-between mt-4">
            <span className="fw-600 text-end flex-grow-1 pe-3">
              <span className="animated-placeholder" style={{ width: '50px' }}></span>
            </span>
            <span className="price text-end fs-5 fw-700 w-auto">
              <span className="animated-placeholder" style={{ width: '60px' }}></span>
            </span>
          </div>
        </div>
        <div className="card-footer bg-transparent border-0 pb-3 pb-sm-4 pb-lg-3 pb-xl-4 px-sm-4 px-lg-3 px-xl-4">
          <button className={`add-to-cart-btn btn btn-secondary d-block fw-700 w-100 mb-2`} type="button" disabled>
            Add to Cart
          </button>
          <button className="buy-now-btn btn btn-outline-secondary d-block fw-700 w-100" type="button" disabled>
            Buy Now
          </button>
        </div>
      </div>
    </>
  );
}
